(function(){
  var hdr=document.getElementById('hdr');
  if(hdr && document.body.classList.contains('tmpl-index')){
    var onScroll=function(){ if(window.scrollY>window.innerHeight*0.82) hdr.classList.add('solid'); else hdr.classList.remove('solid'); };
    onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
  }

  // scroll reveal
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  } else { document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');}); }

  // ensure hero/band video plays
  document.querySelectorAll('video').forEach(function(v){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); });
})();
